module.exports = __webpack_public_path__ + "img/swich_model.b2357e8a.png";